import React from 'react';
import clsx from 'clsx';
import { Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import DictionaryChanger from './DictionaryChanger';
import DictionaryButtons from './DictionaryButtons';

const DatasetDictionaryHeader = ({
  category,
  code,
  dictionaries,
  compact,
}) => (
  <div className={clsx('aridhia-dataset-dictionary-flex', compact && 'flex-column-reverse items-end')}>
    <Header
      as="h4"
      className={clsx(
        'aridhia-dataset-dictionary-header mb-30',
        compact ? 'font-weight-dark-compact mt-20' : 'font-weight-dark pt-6',
      )}
    >
      {dictionaries.length === 0 && (<FormattedMessage id="dictionaries.none.header" />)}
      {dictionaries.length > 0 && (
        <>
          <FormattedMessage id="dataset.dictionary.header" />
          <DictionaryChanger category={category} code={code} />
        </>
      )}
    </Header>
    <DictionaryButtons category={category} code={code} />
  </div>
);

const mapStateToProps = ({
  datasets: {
    datasets,
  },
}, { category, code }) => {
  const dataset = findResult(datasets, category, code);
  const dictionaries = dataset ? dataset.dictionaries : [];

  return (
    {
      dictionaries,
    }
  );
};

export default connect(mapStateToProps)(DatasetDictionaryHeader);
